<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { BlockSocialMediaColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()

const iconColor = computed(
    () => theme.global.current.value.dark
        ? BlockSocialMediaColors.icon.dark
        : BlockSocialMediaColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? BlockSocialMediaColors.background.dark
        : BlockSocialMediaColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="PolicyIconBlockSocialMedia"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
